
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { meApi } from "@/lib/api/me";
import { setMeSession } from "@/lib/auth/storage";
import { normalizePersonCategories } from "@/lib/types";
import { ApiError } from "@/lib/api/client";

export default function MeLoginPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await meApi.login(phone.trim(), pin.trim());
      setMeSession({
        person_id: res.person_id,
        name: res.name,
        phone: res.phone,
        device_pin: res.device_pin,
        person_categories: normalizePersonCategories(res.person_categories),
      });
      navigate("/me");
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : "Invalid phone or PIN. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="flex min-h-screen flex-col justify-center bg-gradient-to-b from-saffron-50 to-background p-6">
      <Card className="mx-auto w-full max-w-sm border-saffron-100 shadow-md">
        <CardHeader className="text-center">
          <p className="text-xs font-semibold uppercase tracking-wider text-saffron-700">
            BCEC Attendance
          </p>
          <CardTitle className="text-xl">Sign in</CardTitle>
          <CardDescription>
            Use your registered phone number and device PIN.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="phone">Phone</Label>
              <Input
                id="phone"
                type="tel"
                inputMode="tel"
                autoComplete="tel"
                placeholder="10-digit mobile"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                className="text-lg"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="pin">Device PIN</Label>
              <Input
                id="pin"
                type="password"
                inputMode="numeric"
                autoComplete="off"
                placeholder="••••"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                required
                className="text-lg tracking-widest"
              />
            </div>
            {error && (
              <p className="text-sm text-red-600" role="alert">
                {error}
              </p>
            )}
            <Button type="submit" className="w-full text-base" size="lg" disabled={loading}>
              {loading ? "Signing in…" : "View my attendance"}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-muted-foreground">
            <Link to="/" className="text-saffron-700 hover:underline">
              ← Back
            </Link>
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
